import React, { FC } from 'react';

export const KNextIcon: FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
        <g clipPath="url(#clip0_9262_49015)">
            <g clipPath="url(#clip1_9262_49015)">
                <path
                    fill="#29CCB1"
                    fillRule="evenodd"
                    d="m3.626 8.362 11.5-6.627a1.75 1.75 0 0 1 1.748 0l11.5 6.627c.542.313.876.89.876 1.517v12.244a1.75 1.75 0 0 1-.876 1.517l-11.5 6.627a1.75 1.75 0 0 1-1.748 0l-11.5-6.627a1.75 1.75 0 0 1-.876-1.517V9.88c0-.626.334-1.204.876-1.517M14.377.435a3.25 3.25 0 0 1 3.246 0l11.5 6.628a3.25 3.25 0 0 1 1.627 2.816v12.244a3.25 3.25 0 0 1-1.627 2.816l-11.5 6.628a3.25 3.25 0 0 1-3.246 0l-11.5-6.628a3.25 3.25 0 0 1-1.627-2.816V9.88a3.25 3.25 0 0 1 1.627-2.816z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill="#000"
                    d="M12 22.25h2.25V8H12zM18.875 11.75h2.75l-4 5.125 4 5.375h-2.75L15.5 17.625v-1.5z"
                ></path>
            </g>
        </g>
        <defs>
            <clipPath id="clip0_9262_49015">
                <path fill="#fff" d="M0 0h32v32H0z"></path>
            </clipPath>
            <clipPath id="clip1_9262_49015">
                <path fill="#fff" d="M0 0h32v32H0z"></path>
            </clipPath>
        </defs>
    </svg>
);
